"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFalse = void 0;
exports.isFalse = (value) => value === false;
//# sourceMappingURL=is-false.js.map